export const PrepareDisclosuresWizardTestIds = {
  ROOT: 'prepare-disclosures-wizard',
  BODY: 'prepare-disclosures-wizard-body',
  FOOTER: 'prepare-disclosures-wizard-footer',
  BACK_BUTTON: 'prepare-disclosures-wizard-back',
  CONTINUE_BUTTON: 'prepare-disclosures-wizard-continue',
  STEP_PLACEHOLDER: 'prepare-disclosures-wizard-step-placeholder',
  CTA: 'prepare-disclosures-cta',
  CTA_DUE_CHIP: 'prepare-disclosures-cta-due-chip',
  CTA_BUTTON: 'prepare-disclosures-cta-button',
  POST_SEND: 'prepare-disclosures-wizard-post-send',
  POST_SEND_TRACKER_LINK: 'prepare-disclosures-wizard-post-send-tracker-link',
  BACK_TO_LOAN_BUTTON: 'prepare-disclosures-wizard-back-to-loan',
};
